/* Small progressive enhancements. Filter/sort forms work without JavaScript. */
(() => {
  'use strict';
  if (window.__oddCleanReady) return;
  window.__oddCleanReady = true;
  function init(root = document) {
    root.querySelectorAll('[data-oh14-tabs]').forEach(strip => {
      const active = strip.querySelector('[aria-current="page"]');
      if (!active) return;
      requestAnimationFrame(() => {
        const r = strip.getBoundingClientRect();
        const a = active.getBoundingClientRect();
        if (a.left < r.left || a.right > r.right) strip.scrollLeft += a.left - r.left - (r.width - a.width) / 2;
      });
    });
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) root.querySelectorAll('.oh14-catalog .oc-filter-form').forEach(form => {
      if (form.querySelector('[name="preview_theme_id"]')) return;
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = 'preview_theme_id'; input.value = preview;
      form.append(input);
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-oh14-options][open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const details = document.querySelector('[data-oh14-options][open]');
    if (!details) return;
    details.open = false; details.querySelector('summary')?.focus({preventScroll: true});
    event.preventDefault();
  });
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
